export default __webpack_public_path__ + "static/media/viewspot-3.5be18146.png";